import { getProfileDataAction } from "./actions.js";
function addProfileReducers(builder) {
  return builder.addCase(getProfileDataAction.pending, (state) => {
    state.eventType = "getProfileData";
    state.status = "pending";
    delete state.error;
  }).addCase(getProfileDataAction.fulfilled, (state, { payload: profileData }) => {
    state.eventType = "getProfileData";
    state.status = "success";
    state.profileData = profileData;
  }).addCase(getProfileDataAction.rejected, (state) => {
    state.eventType = "getProfileData";
  });
}
export {
  addProfileReducers
};
//# sourceMappingURL=profile-reducers.js.map
